// extracted by mini-css-extract-plugin
export var addToCartButton = "_tb-b";
export var arrowButtonContainer = "_tb-9";
export var arrowButtonIcon = "_tb-a";
export var carouselArrowButton = "_tb-6";
export var carouselElementContainer = "_tb-1";
export var left = "_tb-7";
export var productDisplayCarouselContainer = "_tb-0";
export var productTileContainer = "_tb-2";
export var productTileImage = "_tb-4";
export var productTileImageContainer = "_tb-3";
export var productTileTitle = "_tb-5";
export var right = "_tb-8";
export var sliderOverflow = "_tb-c";